<mat-accordion>
  <mat-expansion-panel
    *ngFor="let businessPersonTrainingRequirement of businessPersonTrainingRequirements"
    (opened)="onOpened(businessPersonTrainingRequirement.businessPersonTrainingRequirementId)"
  >
    <mat-expansion-panel-header>{{
      businessPersonTrainingRequirement.eventTitle
    }}</mat-expansion-panel-header>

    <ng-template matExpansionPanelContent>
      <div *ngIf="loading; else auditsLoaded">Loading...</div>

      <ng-template #auditsLoaded>
        <div *ngIf="audits && audits.length > 0; else noAudits">
          <sd-portal-audit-detail-list
            (nextPage)="
              onNextPage(businessPersonTrainingRequirement.businessPersonTrainingRequirementId)
            "
            [audits]="audits"
          ></sd-portal-audit-detail-list>
        </div>
        <ng-template #noAudits> No audit records </ng-template>
      </ng-template>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
